<template>
	<div class="plan_contain plr-16 pt-22">
    <div class="flex list_every pd-16 mb-16" v-for="(item, index) in list" :key="index">
      <img class="plan_img" :src="item.book_cover" alt="">

      <div class="c1 fz-12 ml-16 pt-4 flex1">
        <div class="fz-14 w219 text-hide fw-500 text-hide plan_txt">{{item.book_name}}</div>
        <div class=" h34 w219 text-hide2" :class="{'mtb-11-27': item.is_plan,'mtb-11-21': !item.is_plan }">{{item.book_introduction}}</div>
        <div class="flexs flex-jus c3">
          <div>阅读词汇 {{item.word_base?item.word_base:0}}词</div>
          <div v-if="item.is_plan">已添加</div>
          <div class="add_plan_btn fz-12 fw-500 c1 flexs flex-center" @click="addPlan(item)" v-else>添加计划 <img class="wh_6_8 ml-4" src="../../assets/img/icon/gray_right_arrow_icon.png" alt=""></div>
        </div>
      </div>
    </div>
    <!--<div class="btn_contain">-->
    <!--  <div class="blue_btn" @click="$router.replace('/switchplan')">-->
    <!--    我的计划-->
    <!--  </div>-->
    <!--</div>-->
    <noData v-if="show"></noData>
  	<loading :loadFlag="loadFlag"></loading>
	</div>
</template>
<script>
	import {getEnglishBookList} from '@/api/api.js'
	import noData from "@/components/noData"
	import loading from "@/components/loading"
	export default {
		components: {
			noData,
			loading
		},
		data() {
			return {
			  list: [],
        show: false,
				loadFlag: false
			};
		},
		created() {
		  this.initData()
		},
		methods: {
      async initData(){
        this.loadFlag = true
        const res = await getEnglishBookList()
        this.loadFlag = false
        if(res.code == 1000){
          this.list = res.data
          if(this.list.length == 0){
            this.show = true
					}
        }else {
					 this.$toast(res.msg)
				}
      },
      async addPlan(item){
        if(!item.word_base){
          return this.$toast('单词数为0，无法添加');
        }
        this.$router.replace({ path: '/adjustplan', query:{data: JSON.stringify(item) } })
      }
    }
	};
</script>
<style lang="less" scoped>
.plan_img {
  width: 76px;
  height: 106px;
  box-shadow: 0px 2px 4px 0px rgba(73, 124, 255, 0.14);
  border-radius: 6px;
}


.add_plan_btn {
  width: 74px;
  height: 24px;
  background: #F5F7F9;
  border-radius: 12px;
}

.plan_txt {
  line-height: 14px;
}
</style>
